'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Megamenu } from './lib/Megamenu'
import { IndexKv } from './lib/IndexKv'
import { IndexKvSlider } from './lib/IndexKvSlider'
import { ImgStalker } from './lib/ImgStalker'
import { Tab } from './lib/Tab'
import { Modal } from './lib/Modal'
import { Loading } from './lib/Loading'
import { TextSplit } from './lib/TextSplit'
import { CopyClipboard } from './lib/CopyClipboard'
import { AutowidthSliders } from './lib/AutowidthSliders'
import { EntryForm } from './lib/EntryForm'
import { Zipcode } from './lib/Zipcode'
import { GetFormData } from './lib/GetFormData'
import { RecruitSliderControls } from './lib/recruit/SliderControls'
import { NavigationSidebar } from './lib/NavigationSidebar'
import { RecruitIndexMessage } from './lib/recruit/IndexMessage'
import { BreadCrumbs } from './lib/recruit/BreadCrumbs'

// new CookiePolicy('optout')

new Loading()
new Svg()
new IndexKv()
new TelGrant()
new NavigationSidebar()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Megamenu()
new EntryForm()
new RecruitIndexMessage()
export const autowidthSliders = new AutowidthSliders()
new RecruitSliderControls(autowidthSliders.sliders)
new ImgStalker()
new Tab()
new Modal()
new TextSplit()
new CopyClipboard()
new Zipcode()
new GetFormData()
// new BreadCrumbs()
